<template>
  <v-menu
    v-model="accountMenu"
    :close-on-content-click="false"
    transition="slide-y-transition"
  >
    <template #activator="{ props }">
      <IconButton
        v-bind="props"
        class="navigation-menu__toggle-btn ml-2 mr-2"
        :size="32"
      >
        <UserAvatar
          :size="28"
          :user="data?.user"
        />
      </IconButton>
    </template>

    <v-list class="account-menu">
      <v-list-item>
        <UserAvatar :user="data?.user" />
      </v-list-item>

      <v-list-item
        class="pb-4"
        :title="data?.user?.name || ''"
      >
        <template #subtitle>
          <div class="user-email">
            {{ data?.user?.email || '' }}
          </div>
        </template>
      </v-list-item>

      <v-divider />

      <v-list-item
        title="Profile"
        to="/profile"
        @click="accountMenu = false"
      />

      <v-list-item class="pt-2">
        <LogoutButton />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
const { data } = useAuth();
const accountMenu = ref(false);
const { profile: profileApp } = useApps().bySlug;
</script>

<style scoped>
.account-menu {
  text-align: center;
}

.user-email {
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
